export const SEARCH_BY_CREATOR = 1;
export const SEARCH_BY_PROVIDER = 2;
export const INCLUDE_IN_REPORT = 'include_in_report_';
